import { createContext } from "react";

export type Session = {
  userName: string;
  currentMembership: string;
  clubId: number;
  setClubId: (clubId: number) => void;
  lastManualClubId: number;
  selectClubManually: (clubId: number) => void;
  betaMode: boolean;
};

const SessionContext = createContext<Session>({
  userName: "",
  currentMembership: "",
  clubId: -1,
  setClubId: () => {},
  lastManualClubId: -1,
  selectClubManually: () => {},
  betaMode: false,
});

export function getHomePath({
  userName,
  currentMembership,
}: Pick<Session, "userName" | "currentMembership">): string {
  if (!userName) {
    return "/";
  }
  if (currentMembership === "manager") {
    return "/club";
  }
  if (currentMembership === "player") {
    return "/playerclubselection";
  }
  return "/selectmembership";
}

export default SessionContext;
